import Vue from 'vue';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import buttonLoader from '@/components/button';
import helpers from '@/mixins/helpers';

Vue.use(VeeValidate);
export default {
  mixins: [
    helpers.work_with_date,
  ],
  components: {
    buttonLoader,
  },
  data () {
    return {
      data: {
        Request: {
          checksum: this.$route.query.info,
          timezone: this.getTimeZone(),
          password: '',
        },
      },
      checkSumm: '',
      response: {},
      password: '',
      confirmedPassword: '',
      hidePassword: true,
      view: false,
      mediumRegex: new RegExp('^[a-zA-Z0-9!@#$%^&*+-]{6,21}$'),
      active: false,
      loading: false,
    };
  },
  methods: {
    /* checkPasswords() {
            return this.password == this.confirmedPassword;
        }, */
    checkHash () {
      axios.post(`${this.$store.getters.rootAPI}/user/checkHash`, this.data)
        .then((data) => {
          if (data.data.Status) {
            this.view = true;
          } else {
            this.$router.push({ name: 'auth' });
          }
        });
    },
    setPassword () {
      this.$validator.validateAll().then((result) => {
        this.loading = true;
        if (result == true) {
          this.data.Request.password = this.password;
          axios.post(`${this.$store.getters.rootAPI}/user/restorepassword`, this.data)
            .then((data) => {
              if (data.data.Status) {
                this.$store.dispatch('AUTH_REQUEST', {
                  accessToken: data.data.UserToken,
                  refreshToken: data.data.RefreshToken,
                })
                  .then(() => {
                    this.loading = false;
                    this.$router.replace('/');
                  });
              } else {
                this.loading = false;
                this.$router.push({ name: 'auth' });
              }
            });
        } else {
          this.loading = false;
        }
      });
    },
    mouseOver: function () {
      this.active = !this.active;
    },
  },
  computed: {
    passwordType () {
      return this.hidePassword ? 'password' : 'text';
    },
    passwordIcon () {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash';
    },
    logoPath() {
      return this.$store.getters.logoChanged ? '/img/sew_logo.jpeg' : '/img/logo-dark.png';
    },
  },
  mounted () {
    this.data.Request.checkSum = this.$route.query.info;
    this.checkHash();
  },
};
